import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, UserLabelsService, Alert) {
        this.$state = $state;
        this.UserLabelsService = UserLabelsService;
        this.Alert = Alert;
		
    }

    $onInit() {
        if (!this.users.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }
		
        this.st = new SmartTable();
		this.st.displayedItems=angular.copy(this.labels);
    }

	
    add() {
        //const userIds = this.users.map(({id}) => id);
		const selectedUsers=this.users.filter((e)=>e.roleType);
		const userIds=selectedUsers.map((e) =>e.id);
        this.isSaving = true;
		var companyId=this.companyId;
        this.UserLabelsService
          //  .addCompanyUsers({companyId,labelId}, userIds).$promise
			.addCompanyUsersToLabels({companyId},{ aIds:userIds,bIds:this.st.selectedIds}).$promise
            .then(() => this.$state.go('company.user-directories.saaspass-users.all-users', {}, {reload: '^.^'}))
            .then(() => this.Alert('success', 'company.user-directories.saaspass-users.user-labels.users.copy.copied'))
			.catch((error) =>{ 
						this.Alert('danger', error.data.message)})
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/add/add-users-to-labels.controller.js